import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";

const initPushNotifications = async (store) => {
  // برای پلتفرم‌های نیتیو
  if (Capacitor.isNativePlatform()) {
    try {
      // ایجاد کانال نوتیفیکیشن
      await PushNotifications.createChannel({
        description: "شمال املاک",
        id: "fcm_default_channel",
        importance: 5,
        lights: true,
        name: "شمال املاک",
        sound: "notif",
        vibration: true,
        visibility: 1,
        smallIcon: "ic_notification",
      });

      // درخواست دسترسی
      const permission = await PushNotifications.requestPermissions();
      if (permission.receive === "granted") {
        await PushNotifications.register();
      }

      // تنظیم لیسنرها
      PushNotifications.addListener("registration", (token) => {
        console.log("توکن ثبت شد:", token.value);
        store.commit("setFire", token.value);
      });

      PushNotifications.addListener("registrationError", (error) => {
        console.error("خطا در ثبت:", error);
      });

      PushNotifications.addListener(
        "pushNotificationReceived",
        (notification) => {
          console.log("نوتیفیکیشن دریافت شد:", notification);
        }
      );

      PushNotifications.addListener(
        "pushNotificationActionPerformed",
        (notification) => {
          console.log("عملیات نوتیفیکیشن انجام شد:", notification);
        }
      );
    } catch (error) {
      console.error("خطا در راه‌اندازی نوتیفیکیشن:", error);
    }
  }
};
export default initPushNotifications;
